import * as Constants from './constants'
export const settingListRequest = (formData) => {
  return {
    type: Constants.SETTING_LIST_REQUESTING,
    formData
  }
}

export const settingListSuccess = (data) => {
  return {
    type: Constants.SETTING_LIST_SUCCESS,
    data
  }
}

export const settingListError = (error) => {
  return {
    type: Constants.SETTING_LIST_ERROR,
    error
  }
}

export const settingUpdateStoreRequest = (formData, callback) => {
  return {
    type: Constants.SETTING_UPDATE_STORE_REQUESTING,
    formData,
    callback
  }
}

export const settingUpdateStoreSuccess = (data) => {
  return {
    type: Constants.SETTING_UPDATE_STORE_SUCCESS,
    data
  }
}

export const settingUpdateStoreError = (error) => {
  return {
    type: Constants.SETTING_UPDATE_STORE_ERROR,
    error
  }
}

export const settingGetConfigRequest = (payload, callback) => {
  return {
    type: Constants.SETTING_GET_CONFIG_REQUESTING,
    payload,
    callback
  }
}


// WEBPACK FOOTER //
// ./src/views/Setting/actions.js